import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main__section signup" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "privacy-policy"
}
const _hoisted_5 = { class: "agree-all" }
const _hoisted_6 = {
  for: "agreeAll",
  class: "-medium"
}
const _hoisted_7 = { class: "request-form__footer--actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")
  const _component_PageFrame = _resolveComponent("PageFrame")
  const _directive_simpleHeader = _resolveDirective("simpleHeader")

  return _withDirectives((_openBlock(), _createBlock("main", null, [
    _createVNode("section", _hoisted_1, [
      _createVNode(_component_PageFrame, {
        modelValue: _ctx.state.step,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.step = $event)),
        class: ["form__content", _ctx.isPrivacyPolicy ? '-innerMaxWidth' : '-innerMaxWidthThin']
      }, _createSlots({
        title: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.state.step === 0 ? _ctx.t("pi-agreement") : _ctx.t("sign-up")), 1)
        ]),
        subtitle: _withCtx(() => [
          (_ctx.isPrivacyPolicy)
            ? (_openBlock(), _createBlock("span", _hoisted_2, [
                _createTextVNode(_toDisplayString(_ctx.t("signup-title-1")) + " ", 1),
                _hoisted_3,
                _createTextVNode(" " + _toDisplayString(_ctx.t("signup-title-2")), 1)
              ]))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.t("fill-form-data")), 1)
              ], 64))
        ]),
        content: _withCtx(() => [
          (_ctx.isPrivacyPolicy)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.privacyPolicyContent), {
                  onNextStep: _ctx.nextStep,
                  agreeAll: _ctx.agreeAll,
                  "onUpdate:agreeAll": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agreeAll = $event))
                }, null, 8, ["onNextStep", "agreeAll"]))
              ]))
            : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.signupForm), {
                key: 1,
                ref: "signupForm$",
                onFormStatus: _ctx.onFormStatus
              }, null, 8, ["onFormStatus"]))
        ]),
        action: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            (_ctx.isPrivacyPolicy)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "-button -medium -royalBlue next-button",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.step += 1)),
                  disabled: !_ctx.agreeAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("next")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (!_ctx.isPrivacyPolicy)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  class: "-button -medium -royalBlue signup-button",
                  type: "button",
                  disabled: _ctx.isValidSignupFormData === false,
                  onClick: _ctx.submit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("join")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 2
      }, [
        (_ctx.isPrivacyPolicy)
          ? {
              name: "footer",
              fn: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_Checkbox, {
                    id: "agreeAll",
                    modelValue: _ctx.agreeAll,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreeAll = $event)),
                    binary: true,
                    class: "-royalBlue check-box"
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.t("agree to all terms and conditions.")), 1)
                ])
              ])
            }
          : undefined
      ]), 1032, ["modelValue", "class"])
    ])
  ], 512)), [
    [_directive_simpleHeader]
  ])
}